<template>
  <patientDetailComponent :isMy="false"></patientDetailComponent>
</template>
<script>

import patientDetailComponent from '@/components/patient/patientDetail.vue'
export default {
  name: `patienthospitalhospitalDetail`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientDetailComponent
  }
}
</script>